import React, { useState } from 'react'
import Banner from '../assets/images/hero.png'
import IndiaFlag from '../assets/images/india-flag.png'
import Icon from './Icon'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { NumberPattern, OTPPattern } from '../utils'
import { loginCustomer, verifyCustomerOTP } from '../apis'
import { useDispatch } from 'react-redux'
import { LoggedIn } from '../store/slices/Auth'
import { useNavigate } from 'react-router-dom'

export default ({ open = false, setOpen = () => {}, cb }) => {
  const [ form, setForm ] = useState({ mobile: null, otp: null })
  const [ isOTP, setIsOTP ] = useState(false)
  const dispatch = useDispatch()

  const login = async () => {
    try {
      if( !form.mobile || form.mobile.length < 13 ) return
      await loginCustomer({ mobile: form.mobile })
      setIsOTP(true)
    } catch (error) {
      console.log('error', error)
    }
  }

  const verifyOTP = async () => {
    try {
      if( !form.otp || form.otp.length < 6 ) return
      const customer = await verifyCustomerOTP(form)
      
      if( !cb ){
        dispatch(LoggedIn( customer ))
        window.location.replace('/user')
      } else {
        dispatch(LoggedIn( customer ))
        cb( customer )
      }
      
      setOpen(false)
      // navigate('/user')
      
    } catch (error) {
      console.log('error', error)
    }
  }

  return (
    <div
      className={`modal fade bd-example-modal-lg ${ open && "show"}`}
      style={{ display: "block", backgroundColor: "#000000a8" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content position-relative">
          <div className='position-absolute cursor-pointer' style={{ right: "10px", top:"10px", zIndex: 2 }}>
            <Icon icon={faCircleXmark} className="fs-6 text-secondary "  onClick={() => setOpen(false)} />
          </div>
          <div className='row m-0 p-0 login'>
            <div className='col-lg-6 px-0 img-section'>
              <div style={{  height: "70vh"}}>
                <img src={Banner}  className='w-100 h-100' style={{ borderRadius: "6px 0 0 6px ", objectFit: "cover"}} />
              </div>
            </div>
            <div className='col-lg-6 px-0 position-relative'>
              <div className='p-4'>
                <div className=' pt-4'>
                  <p>Log In or Sign Up</p>
                  <h2 className='text-saffron' style={{ fontWeight: 900}}>Welcome to Dham</h2>
                </div>

                {/* Mobile Number */}
                { !isOTP ?
                  <>
                    <p className='mt-4'>Mobile Number</p>
                    <div className='d-flex align-items-center login-input'>
                      <img src={IndiaFlag} style={{ width: "25px", height: "25px" }} />
                      <p className='mb-0 mx-2'>+91</p>
                      <input className='w-100 search-input p-1 rounded-5' type='text' onChange={(e) => setForm({ ...form, mobile: "+91"+e.target.value })} onInput={NumberPattern} placeholder='1234567890' />
                    </div>
                    <div className='login-btn'>
                      <button className='py-2 search-button w-100 mt-4' onClick={login}>Continue</button>

                    </div>
                  </>

                  : <>
                    <p className='mt-4'>Enter OTP</p>
                    <div className='d-flex align-items-center login-input'>
                      <input className='w-100 search-input p-1 rounded-5 otp' type='text' onChange={(e) => setForm({ ...form, otp: e.target.value })} onInput={OTPPattern} placeholder='123456' />
                    </div>
                    <div className='login-btn'>
                      <button className='py-2 search-button w-100 mt-4' onClick={verifyOTP}>Continue</button>
                      <p className='text-success mb-0 fs-8 mt-4'>OTP is sent successfully.</p>

                    </div>

                  </>
                }

                {/* OTP */}

                <p className='fs-8 position-absolute bottom-0'>By Proceeding, you agree to Dham <a href='#' className='text-primary'>Privacy Policy.</a><br /><a href='#' className='text-primary'>User Agreement</a> and <a href='#' className='text-primary'>Terms of Service</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

